import styled from 'styled-components'

const Pace = styled.div`
  background: rgba(255, 255, 255, 0.6);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`
export default Pace



// WEBPACK FOOTER //
// ./src/components/loaders/Pace.js